// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df8f9856","893":"a0ce996f"}[chunkId] + ".chunk.js";
};